// TO GET MERCHANDISE LIST MAP TO SUPPLIER
export const GET_SUPP_MER_LIST_REQUEST = "GET_SUPP_MER_LIST_REQUEST";
export const GET_SUPP_MER_LIST_SUCCESS = "GET_SUPP_MER_LIST_SUCCESS";
export const GET_SUPP_MER_LIST_FAILURE = "GET_SUPP_MER_LIST_FAILURE";

// TO PUT MERCHANDISE LIST MAP TO SUPPLIER
export const PUT_SUPP_MER_LIST_REQUEST = "PUT_SUPP_MER_LIST_REQUEST";
export const PUT_SUPP_MER_LIST_SUCCESS = "PUT_SUPP_MER_LIST_SUCCESS";
export const PUT_SUPP_MER_LIST_FAILURE = "PUT_SUPP_MER_LIST_FAILURE";